import { Pipe, PipeTransform } from '@angular/core';
import { CareTeamCondition } from '../models/care-team-condition';

@Pipe({ name: 'filtercareTeamConditions' })
export class FilterCareTeamConditionsPipe implements PipeTransform {
  transform(
    conditions: CareTeamCondition[],
    selectedTab: 'OPEN' | 'ACHIEVED' | 'CANCELLED' | 'ALL'
  ): CareTeamCondition[] {
    if (!conditions?.length) {
      return [];
    }

    if (selectedTab === 'ALL') {
      return conditions;
    }

    return conditions.filter((condition) =>
      condition.interventionList?.some((intervention) => intervention.status?.toUpperCase() === selectedTab)
    );
  }
}
